import ApplicationController from './application_controller';
import Rails from "@rails/ujs";

export default class extends ApplicationController {
  static targets = ["searchInput", "searchFilterForm", "results", "spinner"]

  initialize() {
    this.debounceTimeout = null;
    this.request
  }

    disconnect() {
    super.disconnect();
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  search(event) {
    event.preventDefault();

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      this.submitSearch(event);
    }, 250);
  }

  submitSearch(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.setRequestId();
    this.spinnerOn(this.spinnerTarget);
    this.pushQueryParamsToUrl(this.searchFilterFormTarget);
    Rails.fire(this.searchFilterFormTarget, 'submit');
  }

  searchResult(event) {
    event.preventDefault();
    const responseBody = event.detail[0].body;
    const responseRequestId = responseBody.querySelector('#request_id')?.value;

    if (responseRequestId === this.requestId) {
      if (this.hasSpinnerTarget) {
        this.spinnerOff(this.spinnerTarget);
      }
      this.replaceElementWithNewBySingleQuery('.listing-container', event);
      this.replaceElementWithNewBySingleQuery('#pagination', event);
      this.pushQueryParamsToUrl(this.searchFilterFormTarget);
      this.searchInputTarget.focus();
    }
  }
}
